<div class="modol_comp">
  <div class="modal-header pb-0 pt-0">
    <div>
      <button class="button-close" mat-button [mat-dialog-close]="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
        </svg>
      </button>
    </div>
  </div>
  <div class="modal-body p-5">
    <p class="mb-5">Choose Distance API</p>
    <div class="distance-api-container">
      <form [formGroup]="userForm">
        <div class="d-flex justify-content-evenly">
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="distanceAPI" id="AWS" value="AWS" />
            <label class="form-check-label mx-2" for="AWS">AWS API</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="distanceAPI" id="Google" value="Google" />
            <label class="form-check-label mx-2" for="Google">Google API</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="distanceAPI" id="TravelTime" value="TravelTime" [attr.disabled]="true" />
            <label class="form-check-label mx-2" for="TravelTime">Travel Time  API</label>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between mt-4">
    <button type="button" class="btn cancel" [mat-dialog-close]="false">
      Cancel
    </button>
    <button type="submit" class="btn delete mx-3" (click)="onSubmit()">Save</button>
  </div>
</div>